module.exports = __webpack_public_path__ + "static/media/icon-es.a62a83f3.svg";